import type { AppListenerMiddleware } from "@src/store/rootState";
import { createWidget, editWidget } from "@src/store/slices/widgets";
import {
  mpComponentCreated,
  mpComponentEditStarted,
} from "@src/utils/mixpanel";

export function setupMixPanelListener(middleware: AppListenerMiddleware) {
  middleware.startListening({
    actionCreator: createWidget,
    effect: (action) => {
      mpComponentCreated(action.payload, "widget_library");
    },
  });
  middleware.startListening({
    actionCreator: editWidget,
    effect: (action) => {
      mpComponentEditStarted(action.payload.widgetType, "widget_library");
    },
  });
}
